<template>
  <div class="statistics">
    <div>
      <div>{{ generalTotal.deviceTotal || 0 }}</div>
      <span>我的设备</span>
    </div>
    <div>
      <div>
        {{ generalTotal.todayAlarmTotal || 0 }}
      </div>
      <span>今日报警</span>
    </div>
    <div>
      <div>
        {{
           generalTotal.todayInstallDeviceTotal || 0
        }}
      </div>
      <span>今日报装</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {},
  data() {
    return {
      // generalTotal: {deviceCount: 0, realAlarmCount: 0, unReadMsgCount: 0}
    };
  },
  computed: {
    ...mapGetters({ generalTotal: "global/generalTotal" }),
    pushTotal() {
      return (
        parseInt(this.generalTotal.pushAlarmUnReadTotal) +
          parseInt(this.generalTotal.pushDeviceInstallUnReadTotal) +
          parseInt(this.generalTotal.pushSystemNoticeUnReadTotal) || 0
      );
    },
  },
  created() {},
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style lang="less" scoped>
.statistics {
  height: 100%;
  display: flex;
  & > div {
    width: 33.3%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    & > div {
      line-height: 2;
    }
    & > span {
      line-height: 2;
    }
  }
}
</style>
